import { useEffect, useState } from "react";
import classNames from "classnames";
import DropdownIcon from "../ui/DropdownIcon";

function FormCardDetails({
  booking,
  isRollable = false,
  isOpened = true,
  scrolled,
}) {
  const [rollable, setRollable] = useState(isRollable);
  const [opened, setOpened] = useState(true);
  const [afterOpenSkip, setAfterOpenSkip] = useState(false);

  useEffect(() => {
    if (scrolled && !afterOpenSkip) {
      setRollable(true);
      setOpened(false);
    }
    if (afterOpenSkip) {
      setAfterOpenSkip(false);
    }
  }, [scrolled]);

  const openHandler = () => {
    setOpened(true);
    setRollable(false);
    setAfterOpenSkip(true);
  };

  return (
    <>
      {rollable && (
        <div
          className={classNames("listDetails accordionBox", { opened })}
          onClick={openHandler}
        >
          Все условия <DropdownIcon w={14} h={8} fill="#6E6F71" />
        </div>
      )}
      {opened && (
        <>
          <p className="dfsp bookingCard__prepay">
            <span>Предоплата</span>
            <span>{booking.prices.prepayment} ₽</span>
          </p>
          <p className="dfsp">
            <span>На месте</span>
            <span>{booking.prices.payment_on_spot} ₽</span>
          </p>
          <p className="dfsp">
            {booking.base?.cancel_reservation_fee === "no" ? (
              <>
                <span className="bookingCard__cancelPrice">Отмена</span>
                <span className="bookingCard__cancelPrice">бесплатная</span>
              </>
            ) : (
              <>
                <span className="bookingCard__cancelPrice red">
                  Отмена брони
                </span>
                <span className="bookingCard__cancelPrice red">
                  {booking.prices.cancel_fee} ₽
                </span>
              </>
            )}
          </p>
        </>
      )}
    </>
  );
}

export default FormCardDetails;
